import langVarsResolver from "./lang-vars-resolver"

export const getContextOptions = (objContext = {}) => {
  return {
    context: null,
    init: (options = {}) => {
      objContext.context = options.context
    },

    /**
    * Obtiene una traducción para una clave de mensaje, utilizando un contexto de lenguaje si está disponible.
    *
    * @function
    * @param {string | { message: string, keyValues?: Record<string, string> }} keyMessage - La clave del mensaje que se desea traducir. 
    * Puede ser un string simple o un objeto que contenga un mensaje y valores clave para interpolación.
    * @param {string} defaultMessage - El mensaje por defecto que se devolverá si no hay contexto disponible.
    * @returns {string} La traducción del mensaje si existe un contexto, de lo contrario devuelve el mensaje por defecto.
    *
    * @example
    * getTranslatedKey('greeting.hello', 'Hello');
    * 
    * @example
    * getTranslatedKey({ message: 'user.greeting', keyValues: { name: 'Juan' } }, 'Hola');
    */
    getTranslatedKey: (keyMessage, defaultMessage) => {
      let keyValues = {}
      if (typeof keyMessage === 'object' && !keyMessage.code) {
        keyMessage = keyMessage.message
        keyValues = keyMessage.keyValues
      }

      return objContext.context ? langVarsResolver(objContext.context, keyMessage, keyValues) : defaultMessage
    },
  }
}
